export default {
  BUPlanWithdrawSalaryTransfer: 563,
  BUPlanWithdrawTransfer: 55,
  BUPlanWithdrawDeposit: 562,
  BUPlanWithdrawCash: 54,
  BAWithDrawSalary: 163,
  CAPaymentSalary: 110,
};
